import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/system";
import { useI18n } from "../hooks/useI18n";
import { StyledCheckbox } from "./mui/StyledCheckbox";

export const BoosterForm = ({
  sx,
  booster,
  onBoosterChange,
  isReadonly = false,
}: {
  booster: boolean;
  onBoosterChange?: (booster: boolean) => void;
  isReadonly?: boolean;
  sx?: SxProps<Theme> | undefined;
}) => {
  const { t } = useI18n();

  const handleBoosterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    onBoosterChange?.(newValue);
  };

  return (
    <Box sx={{ mt: 0.5, ...sx }}>
      <StyledCheckbox fullWidth disabled={isReadonly} testId="booster">
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleBoosterChange}
              checked={booster}
              name="booster"
              value="yes"
              size="small"
              data-testid="boosterCheckbox"
            />
          }
          label={<Typography variant="body2">{t("vaccines.booster")}</Typography>}
        />
      </StyledCheckbox>
    </Box>
  );
};
